import { DataTool } from '@ztechapps/webui.data-tools'
import { useUsageListContext } from './Context'

export const UsageListDataTool = () => {
  const { usageList, fields, filterCategory } = useUsageListContext()

  // The list result carries the search and filter setters DataTool drives; it is nested under
  // `usageList` here (the context also holds the separate totals query), so it is spread rather
  // than the whole context.
  return (
    <DataTool
      fieldsConfig={fields}
      {...{ searchPlaceHolder: 'Search feature or model', filterCategory, ...usageList }}
      onSort={null}
    />
  )
}
